import { AppState } from "../constants";
import useApplicationState from "./useApplicationState";
export default () => {
  const [device] = useApplicationState(AppState.Device) || [{}];
  return device || {};
};